<template>
  <div class="container">

    <!-- HEADER -->
    <div class="header row p-0 m-0">
      <div class="col-12 col-lg-6 p-0 m-0">
        <img :src="`${publicPath}img/Grupo de desplazamiento 23_.jpg`" data-aos="fade-left" data-aos-duration="1000" class="img-responsive">
      </div>
      <div class="col-12 col-lg-6 text-start p-5 pb-0">
        <h1 class="text-blue mt-3">{{ $t('tecnologia.title') }}</h1>
        <p>{{ $t('tecnologia.apuesta') }}</p>
      </div>
    </div>
    <!-- end HEADER -->

    <section class="p-0 p-lg-5 mx-0 mx-lg-5">
      <div class="g-0 p-0 m-0 px-0 px-lg-5 mt-5 mt-lg-0">
        <h2>{{ $t('tecnologia.digitalizacion') }}</h2>
        <h6 class="text-black my-3"><strong>{{ $t('tecnologia.nuevo_plan') }}</strong></h6>

        <div class="row">
          <div class="col-12 col-lg-4 px-4 mt-5 mt-lg-0 border-end border-light">
            <img :src="`${publicPath}img/Grupo 1888.png`" data-aos="fade-down" data-aos-duration="1000" class="img-responsive mb-3">
            <h3>{{ $t('tecnologia.soluciones') }}</h3>
            <p class="textSmall text-black" v-html="$t('tecnologia.pioneros')"></p>
          </div>
          <div class="col-12 col-lg-4 px-4 mb-5 mb-lg-0 border-end border-light">
            <img :src="`${publicPath}img/Grupo 1897.png`" data-aos="fade-down" data-aos-delay="100" data-aos-duration="1000" class="img-responsive mb-3">
            <h3>{{ $t('tecnologia.estrategia') }}</h3>
            <p class="textSmall text-black">{{ $t('tecnologia.trabajamos') }}</p>
          </div>
          <div class="col-12 col-lg-4 px-4 mb-5 mb-lg-0">
            <img :src="`${publicPath}img/Grupo 1910.png`" data-aos="fade-down" data-aos-delay="200" data-aos-duration="1000" class="img-responsive mb-3">
            <h3>{{ $t('tecnologia.pilares') }}</h3>
            <p class="textSmall text-black" v-html="$t('tecnologia.la_estrategia')"></p>
          </div>
      </div>
      </div>
    </section>

    <section class="p-0 px-lg-5 mx-0 mx-lg-5">
      <div class="container bg-blau">
        <div class="row">
          <div class="col-12 col-lg-6 p-5 pb-0 text-start">
            <img :src="`${publicPath}img/Grupo 1703.png`" class="img-responsive mb-3">
            <h6 class="myriadPro"><strong>{{ $t('tecnologia.oficina') }}</strong></h6>
            <p class="textSmall text-black" v-html="$t('tecnologia.alberto')"></p>
            <div class="row">
              <a href="https://youtu.be/jaAKQLIwaSM" target="_blank" class="btnPlus"><img :src="`${publicPath}img/btnLink.png`" class="img-responsive">  <strong>{{ $t('literals.vervideo') }}</strong></a>
            </div>
          </div>
          <div class="col-12 col-lg-6 p-0 m-0">
            <a href="https://youtu.be/jaAKQLIwaSM" target="_blank"><img :src="`${publicPath}img/Grupo-de-desplazamiento-24_.jpg`" data-aos="fade-left" data-aos-delay="200" data-aos-duration="1000" class="img-responsive"></a>
          </div>
        </div>
      </div>
    </section>

    <section class="p-5 pb-0 mx-0 mx-lg-5">
      <div class="row">
        <h2 class="mb-3 px-0 px-lg-5">{{ $t('tecnologia.privadas') }}</h2>
        <div class="col-12 col-lg-6 text-center text-lg-start pe-0 pe-lg-5">
          <p class="text-black" v-html="$t('tecnologia.proyect_desarr')"></p>
        </div>
        <div class="col-12 col-lg-6">
          <div class="container border border-light p-3 m-0 m-auto" data-aos="fade-in" data-aos-duration="1000" data-aos-id="start-counter-informe">
            <div class="row align-items-center">
              <div class="col-12 col-lg-4 p-0">
                <h2 class="p-0 m-0">
                  <AnimatedNumber
                      ref='counter_usuarias'
                      :startAmount='0'
                      :endAmount='33622'
                      :duration='3'
                      prefix=''
                      suffix=''
                      :separator=separator
                      :decimalSeparator=decimal_separator
                      :decimals='0'
                      :autoinit='true'
                      @finished='counterFinished'
                  /></h2>
                <p class="textSmall">{{ $t('tecnologia.usu_acceso') }}</p>
              </div>
              <div class="col-12 col-lg-4">
                <img :src="`${publicPath}img/Grupo-1879.png`" data-aos="fade-left" data-aos-delay="200" data-aos-duration="1000" data-aos-id="start-counter" class="img-responsive">
              </div>
              <div class="col-12 col-lg-4 p-0">
                <h2 class="p-0 m-0">
                  <AnimatedNumber
                      ref='counter_accesos'
                      :startAmount='0'
                      :endAmount='11935'
                      :duration='3'
                      prefix=''
                      suffix=''
                      :separator=separator
                      :decimalSeparator=decimal_separator
                      :decimals='0'
                      :autoinit='true'
                      @finished='counterFinished'
                  /></h2>
                <p class="textSmall">{{ $t('tecnologia.accesos') }}</p>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-12 col-lg-2 border-end border-light py-3"></div>
              <div class="col-12 col-lg-2"></div>
              <div class="col-12 col-lg-2"></div>
              <div class="col-12 col-lg-2"></div>
              <div class="col-12 col-lg-2 border-end border-light py-3"></div>
              <div class="col-12 col-lg-2"></div>
            </div>
            <div class="row align-items-center">
              <div class="col-12 col-lg-4">
                <h2 class="p-0 m-0">+<AnimatedNumber
                    ref='counter_respecto'
                    :startAmount='0'
                    :endAmount='9'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                />%</h2>
                <p class="textSmall">{{ $t('tecnologia.respecto') }}</p>
              </div>
              <div class="col-12 col-lg-4">
              </div>
              <div class="col-12 col-lg-4">
                <h2 class="p-0 m-0">+<AnimatedNumber
                    ref='counter_respecto_2'
                    :startAmount='0'
                    :endAmount='6'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                />%</h2>
                <p class="textSmall">{{ $t('tecnologia.respecto') }}</p>
              </div>
            </div>
          </div>
          <hr class="filigrana">
        </div>

      </div>
    </section>

    <section class="p-0 p-lg-5 mx-0 mx-lg-5">
      <div class="g-0 p-0 m-0 px-0 px-lg-5">
        <h3>{{ $t('tecnologia.premios') }}</h3>
        <h2>{{ $t('tecnologia.reconocimiento') }}</h2>
        <h6 class="text-black my-3"><strong>{{ $t('tecnologia.noviembre') }}</strong></h6>

        <div class="row">
          <div class="col-12 col-lg-4 px-4 mt-5 mt-lg-0 border-end border-light">
            <h3>{{ $t('tecnologia.gran_empresa') }}</h3>
            <p class="textSmall text-black" v-html="$t('tecnologia.gana_1')"></p>
          </div>
          <div class="col-12 col-lg-4 px-4 mb-5 mb-lg-0 border-end border-light">
            <h3>{{ $t('tecnologia.pyme') }}</h3>
            <p class="textSmall text-black" v-html="$t('tecnologia.gana_2')"></p>
          </div>
          <div class="col-12 col-lg-4 px-4 mb-5 mb-lg-0">
            <h3>{{ $t('tecnologia.institucionales') }}</h3>
            <p class="textSmall text-black"  v-html="$t('tecnologia.gana_3')"></p>
          </div>
        </div>
        <div class="row g-0 my-3">
          <a class="text-center text-black btnPlus" href="https://premios.mutuauniversal.net/es/" target="_blank"><img :src="`${publicPath}img/btnLink.png`" class="img-responsive"> <strong>{{ $t('tecnologia.en_detalle') }}</strong></a>
        </div>

      </div>
    </section>

    <section class="p-0 px-lg-5 mx-0 mx-lg-5">
      <div class="container bg-blau">
        <div class="row">
          <div class="col-12 col-lg-6 p-5 pb-0 text-start">
            <img :src="`${publicPath}img/Grupo 1703.png`" class="img-responsive mb-3">
            <h6 class="myriadPro"><strong>{{ $t('tecnologia.nuestra') }}</strong></h6>
            <p class="textSmall text-black" v-html="$t('tecnologia.maria')"></p>
            <div class="row">
              <a href="https://youtu.be/WS5-_9MXrBo" target="_blank" class="btnPlus"><img :src="`${publicPath}img/btnLink.png`" class="img-responsive">  <strong>{{ $t('literals.vervideo') }}</strong></a>
            </div>
          </div>
          <div class="col-12 col-lg-6 p-0 m-0">
            <a href="https://youtu.be/WS5-_9MXrBo" target="_blank"><img :src="`${publicPath}img/Grupo-de-desplazamiento-33.jpg`" data-aos="fade-left" data-aos-delay="200" data-aos-duration="1000" class="img-responsive"></a>
          </div>
        </div>
      </div>
    </section>

  </div>

  <div class="container-fluid p-0 m-0 mt-5 g-0">
    <section class="p-0 m-0 g-0">
      <h3>{{ $t('tecnologia.entrega') }}</h3>

      <div class="visor m-0 p-0 g-0">

        <div class="row filaA">
          <div class="col img-home">
            <img :src="`${publicPath}img/Grupo de desplazamiento 31_.jpg`" data-aos-delay="100" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/Grupo de desplazamiento 26_.jpg`" data-aos-delay="200" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/Grupo de desplazamiento 34.jpg`" data-aos-delay="300" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/Grupo de desplazamiento 29_.jpg`" data-aos-delay="400" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/Grupo de desplazamiento 35.jpg`" data-aos-delay="500" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
        </div>

      </div>
    </section>
  </div>
  <div class="container">

    <section class="p-0 p-lg-5 mx-0 mx-lg-5">
      <div class="container bg-blau p-3 m-0 mt-5 mt-lg-0 px-lg-5 py-lg-5">
        <h5 class="mb-4">{{ $t('literals.contribucion_a_los_ods') }}</h5>
        <div class="row justify-content-center">
          <div class="col-3 col-lg-1 p-0 m-2">
            <img :src="`${publicPath}img/${locale}ODS03.png`" data-aos="fade-left" data-aos-delay="100" data-aos-duration="1000" class="img-responsive">
          </div>
          <div class="col-3 col-lg-1 p-0 m-2">
            <img :src="`${publicPath}img/${locale}ODS08.png`" data-aos="fade-left" data-aos-delay="200" data-aos-duration="1000" class="img-responsive">
          </div>
          <div class="col-3 col-lg-1 p-0 m-2">
            <img :src="`${publicPath}img/${locale}ODS09.png`" data-aos="fade-left" data-aos-delay="300" data-aos-duration="1000" class="img-responsive">
          </div>
          <div class="col-3 col-lg-1 p-0 m-2">
            <img :src="`${publicPath}img/${locale}ODS11.png`" data-aos="fade-left" data-aos-delay="400" data-aos-duration="1000" class="img-responsive">
          </div>
          <div class="col-3 col-lg-1 p-0 m-2">
            <img :src="`${publicPath}img/${locale}ODS17.png`" data-aos="fade-left" data-aos-delay="500" data-aos-duration="1000" class="img-responsive">
          </div>
        </div>
      </div>
    </section>


    <!-- NAVEGACIÓ PRE-FOOTER -->
    <hr>
    <div class="row p-0 g-0 mb-3">
      <div class="col-6 p-0 m-0 pb-3 text-start">
        <localized-link class="footerLink" to="/nuestra-actuacion-en-2021/acciones-de-prevencion"><img :src="`${publicPath}img/arrowLeft.png`" class="img-responsive arrowsFooter"> {{ $t("nav.acciones-de-prevencion") }}</localized-link>
      </div>
      <div class="col-6 p-0 m-0 pb-3 text-end textSmall">
        <localized-link class="footerLink" to="/nuestra-actuacion-en-2021/organizacion-y-buen-gobierno">{{ $t("nav.organizacion-y-buen-gobierno") }} <img :src="`${publicPath}img/arrowRight.png`" class="img-responsive arrowsFooter"></localized-link>
      </div>
    </div>

  </div>
</template>


<script>
import AnimatedNumber from "vue3-autocounter";

export default {
  components: {
    AnimatedNumber,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      separator: '.',
      decimal_separator: ',',
      locale:this.$i18n.locale,
    }
  },
  mounted() {
    document.addEventListener('aos:in:start-counter', this.startCounter);
    if(this.$i18n.locale=="en"){
      this.separator = ',';
      this.decimal_separator = '.';
    } else {
      this.separator = '.';
      this.decimal_separator = ',';
    }
  },
  methods: {
    startCounter() {
      if (this.$refs.counter_usuarias != null) {
        this.$refs.counter_usuarias.start();
      }
      if (this.$refs.counter_accesos != null) {
        this.$refs.counter_accesos.start();
      }
      if (this.$refs.counter_respecto != null) {
        this.$refs.counter_respecto.start();
      }
      if (this.$refs.counter_respecto_2 != null) {
        this.$refs.counter_respecto_2.start();
      }
    }
  }
}
</script>

